import { render, staticRenderFns } from "./TalkToUsButton.vue?vue&type=template&id=2f8b7b5c&"
import script from "./TalkToUsButton.vue?vue&type=script&lang=js&"
export * from "./TalkToUsButton.vue?vue&type=script&lang=js&"
import style0 from "./TalkToUsButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports